/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export const listColorCollection = [
    { color: '#A5397A' },
    { color: '#B6424C' },
    { color: '#D65E43' },
    { color: '#386A75' },
    { color: '#1D5190' },
    { color: '#6264A7' },
];

export const fontIcons = [
    { name: 'MoreSports' },
    { name: 'ContactCard' },
    { name: 'Airplane' },
    { name: 'Tag' },
    { name: 'PaymentCard' },
    { name: 'MountainClimbing' },
    { name: 'GiftCard' },
    { name: 'Archive' },
    { name: 'DateTime2' },
    { name: 'Repair' },
    { name: 'Clock' },
    { name: 'ReceiptCheck' },
    { name: 'AllCurrency' },
    { name: 'ShopServer' },
    { name: 'Money' },
    { name: 'ActivateOrders' },
    { name: 'RecurringEvent' },
    { name: 'Car' },
    { name: 'Home' },
    { name: 'AppIconDefault' },
    { name: 'AirTickets' },
    { name: 'DocumentSet' },
    { name: 'EMI' },
    { name: 'NewTeamProject' },
    { name: 'TextDocumentShared' },
    { name: 'WorkforceManagement' },
    { name: 'Feedback' },
    { name: 'WaitlistConfirm' },
    { name: 'EntitlementPolicy' },
];
